import { render, staticRenderFns } from "./banbenselect.vue?vue&type=template&id=f93fd1fc&scoped=true"
import script from "./banbenselect.vue?vue&type=script&lang=js"
export * from "./banbenselect.vue?vue&type=script&lang=js"
import style0 from "./banbenselect.vue?vue&type=style&index=0&id=f93fd1fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93fd1fc",
  null
  
)

export default component.exports